import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { AmberApi } from 'app/core/models/api-helpers';
import { RequestService } from 'app/core/services/request.service';
import { ConfigService } from 'app/core/services/config.service';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class DynamicOnboardingService {
  private profile$: Observable<any>;
  private agoraDomain$: Observable<any>;
  private domain$: Observable<any>;
  private reloadProfile$ = new Subject<void>();
  private reloadAgoraDomain$ = new Subject<void>();
  private reloadDomain$ = new Subject<void>();
  
  constructor(
    private profileService: ProfileService,
    private configService: ConfigService,
    private requestService: RequestService
  ) { }


  resetProfile() {
    this.reloadProfile$.next();
    this.profile$ = null;
  }

  resetAgoraDomain() {
    this.reloadAgoraDomain$.next();
    this.agoraDomain$ = null;
  }

  resetDomain() {
    this.reloadDomain$.next();
    this.domain$ = null;
  }
  getDomainDetails(): Observable<any> {
    if (!this.domain$) {
      let url = this.configService.get('server').url +
        this.configService.get('endpoints').organization.domain.details.api;
      this.domain$ = this.requestService.get(url).takeUntil(this.reloadDomain$).extract(AmberApi.Data).shareReplay(1);
    }
    return this.domain$;
  }

  getOrganizationDetails(): Observable<any> {
    let url = this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.details.api;
    return this.requestService.get(url).extract(AmberApi.Data);
  }

  getEmployeeDetails(): Observable<any> {
    if (!this.profile$) {
      this.profile$ = this.profileService.getProfile().takeUntil(this.reloadProfile$).extract(AmberApi.Data)
      .filter(body => this.checkIfIncludeBuyerOrSelleGroup(body['groups'])).shareReplay(1);
    }
    return this.profile$;
  }

  getRoles(): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.employeeRoles.api;
    return this.requestService.get(url).extract(AmberApi.Data);
  }

  getUserGuidance(userId: string, key: string = ''): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').amber.users.getGuidance.api + '/' + userId + '?key=' + key;
    return this.requestService.get(url);
  }

  setUserGuidance(userId: string, body: { key: string, completed?: boolean, viewed?: boolean, reminder?: boolean }): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').amber.users.getGuidance.api + '/' + userId;
    return this.requestService.post(url, body);
  }

  getAccountDomain(): Observable<any> {
    if (!this.agoraDomain$) {
      let url = this.configService.get('server').url + this.configService.get('endpoints').agora.accounts.domain.api;
      this.agoraDomain$ = this.requestService.get(url).takeUntil(this.reloadAgoraDomain$).extract(AmberApi.Data).shareReplay(1);
    }
    return this.agoraDomain$;
  }

  private checkIfIncludeBuyerOrSelleGroup(groups: Array<string>) {
    let result;
    if (groups.length > 0) {
      groups.find(el => {
        return result = (el.includes('buyer') || el.includes('seller'))
      })
    } else {
      result = false
    }
    return result;
  }

  getHistory(): Observable<any> {
    return Observable.of([]);
  }

  getEmployees() {
    let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.list.api;
    return this.requestService.get(url).extract(AmberApi.Data).shareReplay(1);
  }

  addEmployee(details: any) {
    let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.add.api;
    return this.requestService.post(url, details);
  }

  whitespaceValidation(): ValidatorFn {
    return (c: AbstractControl): { [key: string]: any } => {
      return c.value ? c.value.trim().length === 0 ? { custom: { message: 'value should contain more than whitespaces' } } : null : null;
    }
  }

  
}



// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/dynamic-onboarding.service.ts